import React from "react";
import styled from "styled-components";
import ProductIcon from "../components/ProductIcon";
import { Colors } from "../components/styles/Colors";

const Wrapper = styled.div`
  background: ${Colors.hunter};
  display: flex;
  flex-wrap: wrap;

  justify-content: space-around;

  padding: 32px 0;

  > div {
    width: 50%;
  }
`;

export default function ProductIcons({ product }) {
  const icons = product.calloutIcons.map((icon) => <ProductIcon icon={icon} />);

  return <Wrapper>{icons}</Wrapper>;
}
